import { render, staticRenderFns } from "./AuthPersonal.vue?vue&type=template&id=bc68f62e&"
import script from "./AuthPersonal.vue?vue&type=script&lang=js&"
export * from "./AuthPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports